import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import type {
  HeatExchangerDynamicOutputs,
  HeatExchangerInputs,
  HeatExchangerOutputs,
  HeatExchangerParams,
  HeatExchangerState,
} from './types';

/** Qobiq-quvurli issiqlik almashinuvchi — UnitModel. */
export const heatExchanger: UnitModel<
  HeatExchangerParams,
  HeatExchangerInputs,
  HeatExchangerState,
  HeatExchangerDynamicOutputs,
  HeatExchangerOutputs
> = {
  id: 'heat-exchanger',
  init: (params, inputs) => initState(params, inputs),
  step: stepDynamic,
  steady: solveSteady,
};

export * from './types';
export { solveSteady, computeU } from './steady';
export { initState, stepDynamic, storedEnergy, DEFAULT_CELLS } from './dynamic';
export * from './effectiveness';
export * from './geometry';
export * from './correlations';
